import type { Id } from './types';

export type IdGen = () => Id;

const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';

/** nanoid-style random ids (64-symbol alphabet, 6 bits per character). */
export function randomIdGen(
  size = 12,
  fillRandom: (bytes: Uint8Array<ArrayBuffer>) => void = (bytes) => crypto.getRandomValues(bytes),
): IdGen {
  return () => {
    const bytes = new Uint8Array(size);
    fillRandom(bytes);
    let id = '';
    for (const byte of bytes) id += ALPHABET.charAt(byte & 63);
    return id;
  };
}

/** Deterministic ids for tests: `id1`, `id2`, … */
export function sequentialIdGen(prefix = 'id'): IdGen {
  let n = 0;
  return () => `${prefix}${String(++n)}`;
}

/** The real clock; injectable everywhere else as `now: () => Date`. */
export function systemNow(): Date {
  return new Date();
}
